module.exports = __webpack_public_path__ + "static/media/avatars_male_4.d97be35b.png";